module.exports = __webpack_public_path__ + "media/בנה.050e40c1.mp3";